export const COGNITO = {
  REGION: 'ap-southeast-2',
  USER_POOL_ID: 'ap-southeast-2_qa948hnf9',
  APP_CLIENT_ID: '561hvsrokq5ciig08614jh4nke',
}
